<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      新規登録（産廃回収）
    </h2>
    <order-form />
  </v-container>
</template>
<script>
import OrderForm from './_Form'
export default {
  name: 'DriverOrderAcceptCollectionNew',
  components: {
    OrderForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true },
        { text: '新規登録', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>
